import { createFilters, FilterState, useDebouncedTableFilter, useTableFilter } from '@Component/Filter/utils.ts';
import { getTaxcardYearOptions } from '@Page/EmployeeOverview/Taxcard/TaxcardYearDropdownOptions';
import { useIntl } from 'react-intl';

export function useEmployeeOverviewFilters(): FilterState {
    const intl = useIntl();
    return createFilters({
        searchFilter: useDebouncedTableFilter(
            {
                label: intl.formatMessage({ id: 'text_search' }),
                name: 'query',
                dontSendAsQueryParam: true,
                placement: 'main',
            },
            250,
        ),
        viewFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_view_options' }),
            name: 'view',
            defaultValue: ['details'],
            placement: 'main',
        }),
        departmentFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_department' }),
            labelPlural: intl.formatMessage({ id: 'text_departments' }),
            name: 'departmentIds',
        }),
        employeeAvailabilityFilter: useTableFilter({
            label: intl.formatMessage({
                id: 'text_include_inactive_employees',
            }),
            name: 'employeeAvailability',
            query: (searchParam: string) => (searchParam === 'true' ? 'ALL' : 'ACTIVE'),
        }),
        employeeCategoryFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_employee_category' }),
            labelPlural: intl.formatMessage({ id: 'text_employee_categories' }),
            name: 'employeeCategoryIds',
            placement: 'overflow',
        }),
        employeeAttestantsFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_employee_attestant' }),
            labelPlural: intl.formatMessage({ id: 'text_employee_attestants' }),
            name: 'employeeAttestantsIds',
            placement: 'overflow',
        }),
        divisionFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_division' }),
            labelPlural: intl.formatMessage({ id: 'text_divisions' }),
            name: 'divisionIds',
            placement: 'overflow',
        }),
        deliveryMethodWageSlipListFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_payslip_to' }),
            labelPlural: intl
                .formatMessage({
                    id: 'tsk_text_payslip_delivery_methods',
                })
                .toLowerCase(),
            name: 'deliveryMethodWageSlipList',
            placement: 'overflow',
        }),
        salaryContactsFilter: useTableFilter({
            label: intl.formatMessage({
                id: 'text_view_contacts_with_wage_reporting',
            }),
            name: 'includeContactsWithSalary',
            placement: 'overflow',
        }),
        systemAccessContactsFilter: useTableFilter({
            label: intl.formatMessage({
                id: 'text_view_user_contacts',
            }),
            name: 'includeContactsWithSystemAccess',
            placement: 'overflow',
        }),
        onlySystemAccessFilter: useTableFilter({
            label: intl.formatMessage({
                id: 'text_view_employees_with_login_access',
            }),
            name: 'onlyWithSystemAccess',
            placement: 'overflow',
        }),
        taxcardYearFilter: useTableFilter({
            label: `${intl.formatMessage({
                id: 'text_tax_deduction_card',
            })} ${intl
                .formatMessage({
                    id: 'text_year',
                })
                .toLowerCase()}`,
            name: 'year',
            options: getTaxcardYearOptions().options,
            defaultValue: [getTaxcardYearOptions().year],
            placement: 'overflow',
        }),
    });
}
